var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"width":"100%","height":"53.33vw"}},[_c('div',{ref:"main",staticStyle:{"width":"100%","height":"50vw"}}),_c('p',{staticStyle:{"font-size":"12px","font-weight":"normal","text-align":"center","margin-top":"1.04vw","color":"#6d6d6d"}},[_vm._v("\n    *地图经过变形处理，仅供参考。\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }